var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-page",style:(("min-height: " + _vm.pageMinHeight + "px"))},[_c('h1',[_vm._v(_vm._s(_vm.$t('content')))])])}
var staticRenderFns = []

export { render, staticRenderFns }